import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Unstake your {asset}',
  description: 'How much would you like to unstake from the Safety Module?',
  currentlyStaked: 'Currently staked',
  unstake: 'Unstake',
});
